<div class="email-delivery" data-automation-id="email-delivery-container">
    <div class="header-bar" data-automation-id="email-delivery-header">
        <button type="button" data-automation-id="email-delivery-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="email-delivery-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDisabled()" *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="email-delivery-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #emailDeliveryForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="top-panel">
            <res-custom-checkbox class="enable-delivery-checkbox" automationId="email-delivery-enable"
                name="emailDeliveryEnabled" [(ngModel)]="emailDeliveryEnabled" content="Enable Email Delivery"
                [isDisabled]="!casePermissions && !hasPermissions" (ngModelChange)="toggleCheckbox()">
            </res-custom-checkbox>
        </div>
        <div class="content-panel">
            <div class="left-content">
                <div class="labels-container">
                    <span>Deliver</span>
                    <span>• Workflow Reports</span>
                    <span>• Export Comparison Reports</span>
                </div>
            </div>
            <div class="right-content">
                <p class="to-label">
                    <span>To</span>
                </p>
                <div class="text-area-container">
                    <res-key-value-list [placeholderField1]='"Enter one per line or paste multiple ... "'
                        [rows]="emailRecipients" [queryColumnHidden]="true" automationId="email-delivery-"
                        [validateName]="false" [maxNameLength]="255" [isDisabled]="!hasPermissions">
                    </res-key-value-list>
                </div>
            </div>
        </div>
    </form>
</div>